import { i18n } from '@/plugins/i18n';
import { getLanguageCode } from '@/util/i18n/get-language-code';

export function setDocumentTitle(key) {
  document.title = key ? i18n.t(key) + ' | ' + i18n.t('title.default') : i18n.t('title.default');
}

export function setDocumentLang(locale) {
  const languageCode = getLanguageCode(locale);

  const html = document.documentElement;

  html.setAttribute('lang', languageCode);
}
